import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Login from "./pages/Login";
import Home from "./pages/Home/Home";
import Instances from "./pages/Instances/Instances";
import Users from "./pages/Admin/Users/Users";
import ActivityLogs from "./pages/Admin/ActivityLogs/ActivityLogs";
import ProtectedRoute from "./components/ProtectedRoute";
import Projects from "./pages/Projects/Projects";
import SkeyenoteNotes from "./pages/Skeyenote/SkeyenoteNotes/SkeyenoteNotes";
import SkeyenoteUsers from "./pages/Skeyenote/SkeyenoteUsers/SkeyenoteUsers";
import SkeyechartsDashboards from "./pages/Skeyecharts/SkeyechartsDashboards/SkeyechartsDashboards";
import SkeyechartsDatasources from "./pages/Skeyecharts/SkeyechartsDatasources/SkeyechartsDatasources";
import SkeyechartsUsers from "./pages/Skeyecharts/SkeyechartsUsers/SkeyechartsUsers";
import SkeyeingestPipelines from "./pages/Skeyeingest/SkeyeingestPipelines/SkeyeingestPipelines";
import SkeyeingestUsers from "./pages/Skeyeingest/SkeyeingestUsers/SkeyeingestUsers";
import SkeyeingestExecutors from "./pages/Skeyeingest/SkeyeingestExecutors/SkeyeingestExecutors";
import SkeyepredictProjects from "./pages/Skeyepredict/SkeyepredictProjects/SkeyepredictProjects";
import SkeyepredictUsers from "./pages/Skeyepredict/SkeyepredictUsers/SkeyepredictUsers";
import SkeyecubeProjects from "./pages/Skeyecube/SkeyecubeProjects/SkeyecubeProjects";
import SkeyecubeUsers from "./pages/Skeyecube/SkeyecubeUsers/SkeyecubeUsers";
import SkeyeformUsers from "./pages/Skeyeform/SkeyeformUsers/SkeyeformUsers";
import JeyedaProjects from "./pages/Jeyeda/JeyedaProjects/JeyedaProjects";
import JeyedaUsers from "./pages/Jeyeda/JeyedaUsers/JeyedaUsers";
import JeyedaDatasources from "./pages/Jeyeda/JeyedaDatasources/JeyedaDatasources";
import BigDataHadoop from "./pages/Hadoop/Hadoop";
import BigDataHive from "./pages/Hive/Hive";
import SkeyeStudio from "./pages/SkeyeStudio/SkeyeStudio";
import NotFoundPage from "./pages/404Page";
import Profile from "./pages/Profile";
import FahrasUsers from "./pages/Fahras/FahrasUsers";
import DGHelperUsers from "./pages/DGHelper/DGHelperUsers";
import { useContext } from "react";
import { AuthContext } from "./services/authcontext";
import ErrorBoundary from "./components/ErrorBoundary";

const getRouteComponent = (path) => {
  switch (path) {
    case "/":
      return <Home />;
    case "/instances":
      return <Instances />;
    case "/Users":
      return <Users />;
    case "/Activity-Logs":
      return <ActivityLogs />;
    case "/projects":
      return <Projects />;
    case "/skeyenote/notes":
      return <SkeyenoteNotes />;
    case "/skeyenote/users":
      return <SkeyenoteUsers />;
    case "/skeyecharts/dashboards":
      return <SkeyechartsDashboards />;
    case "/skeyecharts/datasources":
      return <SkeyechartsDatasources />;
    case "/skeyecharts/users":
      return <SkeyechartsUsers />;
    case "/skeyeingest/pipelines":
      return <SkeyeingestPipelines />;
    case "/skeyeingest/users":
      return <SkeyeingestUsers />;
    case "/skeyeingest/executors":
      return <SkeyeingestExecutors />;
    case "/skeyepredict/projects":
      return <SkeyepredictProjects />;
    case "/skeyepredict/users":
      return <SkeyepredictUsers />;
    case "/skeyecube/projects":
      return <SkeyecubeProjects />;
    case "/skeyecube/users":
      return <SkeyecubeUsers />;
    case "/skeyeform/users":
      return <SkeyeformUsers />;
    case "/jeyeda/projects":
      return <JeyedaProjects />;
    case "/jeyeda/users":
      return <JeyedaUsers />;
    case "/jeyeda/datasources":
      return <JeyedaDatasources />;
    case "/big-data/hadoop":
      return <BigDataHadoop />;
    case "/big-data/hive":
      return <BigDataHive />;
    case "/skeyestudio":
      return <SkeyeStudio />;
    case "/profile":
      return <Profile />;
    case "/fahras/users":
      return <FahrasUsers />;
    case "/dghelper/users":
      return <DGHelperUsers />;
    default:
      return <NotFoundPage />;
  }
};
const allRoutes = [
  { path: "/", pageTitle: "Home" },
  { path: "/instances", pageTitle: "Instances" },
  { path: "/projects", pageTitle: "Projects" },
  { path: "/skeyenote/notes", pageTitle: "Skeyenote Notes" },
  { path: "/skeyenote/users", pageTitle: "Skeyenote Users" },
  { path: "/skeyecharts/dashboards", pageTitle: "Skeyecharts Dashboards" },
  { path: "/skeyecharts/datasources", pageTitle: "Skeyecharts Datasources" },
  { path: "/skeyecharts/users", pageTitle: "Skeyecharts Users" },
  { path: "/skeyeingest/pipelines", pageTitle: "Skeyeingest Pipelines" },
  { path: "/skeyeingest/users", pageTitle: "Skeyeingest Users" },
  { path: "/skeyeingest/executors", pageTitle: "Skeyeingest Executors" },
  { path: "/skeyepredict/projects", pageTitle: "Skeyepredict Projects" },
  { path: "/skeyepredict/users", pageTitle: "Skeyepredict Users" },
  { path: "/skeyecube/projects", pageTitle: "Skeyecube Projects" },
  { path: "/skeyecube/users", pageTitle: "Skeyecube Users" },
  { path: "/skeyeform/users", pageTitle: "Skeyeform Users" },
  { path: "/fahras/users", pageTitle: "Fahras Users" },
  { path: "/jeyeda/projects", pageTitle: "Jeyeda Projects" },
  { path: "/jeyeda/users", pageTitle: "Jeyeda Users" },
  { path: "/jeyeda/datasources", pageTitle: "Jeyeda Datasources" },
  { path: "/dghelper/users", pageTitle: "DG Helper Users" },
  { path: "/big-data/hadoop", pageTitle: "Big Data Hadoop" },
  { path: "/big-data/hive", pageTitle: "Big Data Hive" },
  { path: "/skeyestudio", pageTitle: "SkeyeStudio" },
  { path: "/profile", pageTitle: "Profile" },
  { path: "/Users", pageTitle: "Users" },
  { path: "/Activity-Logs", pageTitle: "Activity Logs" },
];

function App() {
  const { user, isAuthenticated } = useContext(AuthContext);
  const userData = user;
  const userRole = userData?.roles?.[0]?.name;
  const activatedModules =
    userData?.activatedModules?.map((m) => m.label.toLowerCase()) || [];

  const filteredRoutes = allRoutes.filter((route) => {
    if (userRole === "ROLE_ADMIN") {
      return ["/Users", "/Activity-Logs", "/profile"].includes(route.path);
    } else {
      // General routes available to managers/users
      if (
        ["/", "/instances", "/projects", "/skeyestudio", "/profile"].includes(
          route.path,
        )
      )
        return true;

      // Extract module base path (e.g., "/skeyecharts/dashboards" -> "skeyechart")
      const routeBase = route.path.split("/")[1];

      // Handle special alias mappings like Skeyecharts -> Skeyechart api label
      if (routeBase === "skeyecharts")
        return activatedModules.includes("skeyechart");
      if (routeBase === "big-data")
        return (
          activatedModules.includes("hadoop") ||
          activatedModules.includes("hive")
        );

      return activatedModules.includes(routeBase);
    }
  });

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to={userRole === "ROLE_ADMIN" ? "/Users" : "/"} replace />
          ) : (
            <Login />
          )
        }
      />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <MainLayout>
              <ErrorBoundary>
                <Routes>
                  {filteredRoutes.map((routeItem) => (
                    <Route
                      key={routeItem.path}
                      path={routeItem.path}
                      element={getRouteComponent(routeItem.path)}
                    />
                  ))}
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </ErrorBoundary>
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
